var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfileImage = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "#EEEEEE",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "currentcolor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_300_33651",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17,
    fill: "#3B3B3B",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_300_33651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 35H5C5 27.8203 10.5964 22 17.5 22C24.4036 22 30 27.8203 30 35Z",
    fill: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 13.5,
    r: 5.5,
    fill: "#3B3B3B"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfileImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile-image.13e0d9a702e4a5f477ae754287097039.svg";